// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"CustomTable_custom_table__kYgec","nodata":"CustomTable_nodata__3LPPD"};